import { render } from "./ScoreBoard.vue?vue&type=template&id=63c46b3e&scoped=true"
import script from "./ScoreBoard.vue?vue&type=script&lang=js"
export * from "./ScoreBoard.vue?vue&type=script&lang=js"

import "./ScoreBoard.vue?vue&type=style&index=0&id=63c46b3e&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c46b3e"]])

export default __exports__